module.exports = __webpack_public_path__ + "static/media/Sec-1_HomePageWeb_CN.7bbdc253.webp";